import { render, staticRenderFns } from "./WsTitle001.vue?vue&type=template&id=2d2e6550"
import script from "./WsTitle001.vue?vue&type=script&lang=js"
export * from "./WsTitle001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports